
import { useState } from "react";
import { Plus, Trash2, Copy } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ScrollArea } from "@/components/ui/scroll-area";
import { CodeItem } from "./CodeItem";

interface CodeListProps {
  codes: Array<{ code: string; title: string | null }> | null;
  onCopyCode: (code: string) => Promise<void>;
  onCopyUrl: (code: string) => Promise<void>;
  onShowQr: (code: string) => void;
  onEditCode: (code: string, title: string | null) => void;
  onDeleteCode: (code: string) => void;
  onAddCodes: () => void;
  onDeleteAll: () => void;
  onCopyAll: () => void;
}

export const CodeList = ({
  codes,
  onCopyCode,
  onCopyUrl,
  onShowQr,
  onEditCode,
  onDeleteCode,
  onAddCodes,
  onDeleteAll,
  onCopyAll
}: CodeListProps) => {
  return (
    <div>
      <div className="flex items-center justify-between mb-2">
        <h3 className="font-medium">Códigos ({codes?.length || 0})</h3>
        <div className="flex gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              onAddCodes();
            }}
            className="gap-1"
          >
            <Plus className="h-4 w-4" />
            Añadir códigos
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={onDeleteAll}
            className="gap-1 text-red-600 hover:text-red-700 hover:bg-red-50"
          >
            <Trash2 className="h-4 w-4" />
            Eliminar todos
          </Button>
          <Button variant="outline" size="sm" onClick={onCopyAll} className="gap-1">
            <Copy className="h-4 w-4" />
            Copiar todos
          </Button>
        </div>
      </div>
      <ScrollArea className="h-[400px] rounded-md border p-4">
        <div className="grid grid-cols-3 gap-2">
          {codes?.map(code => (
            <CodeItem
              key={code.code}
              code={code}
              onCopyCode={onCopyCode}
              onCopyUrl={onCopyUrl}
              onShowQr={onShowQr}
              onEditCode={onEditCode}
              onDeleteCode={onDeleteCode}
            />
          ))}
        </div>
      </ScrollArea>
    </div>
  );
};
